'use strict'

var Backbone = require('backbone')
var Marionette = require('marionette')
var App = require('app')

var List = require('./list')

// var Schedule = require('./schedule')

// var ShowController = require('./show')

var Header = function () {
  // 
  var API = {
    list: function () {
      var list = new List()
    }
  }

  App.globalChannel.on('app:start', function () {
    // console.log('go')
    API.list()
  })

  // App.globalChannel.on('device:edit', function (options) {
  //   API.editDevice({model: options.model, region: App.rootLayout.getRegion('dialogRegion')})
  // })

  // App.globalChannel.on('device:schedule', function (options) {
  //   API.showDeviceSchedule(options)
  // })

  // App.globalChannel.on('device:schedule-control', function (options) {
  //   API.controlDevice({model: options.model, device: options.device, collection: options.collection, region: App.rootLayout.getRegion('dialogRegion'), controlType: 'schedule'})
  // })

  // App.globalChannel.on('device:control', function (options) {
  //   API.controlDevice({model: options.model, region: App.rootLayout.getRegion('dialogRegion')})
  // })
  // App.globalChannel.on('device:show', function (options) {
  //   App.globalChannel.trigger('app:navigate', 'device/' + options.model.id)
  //   API.showDevice(options.model.id, options.model)
  // // console.log(client)
  // })
  // App.vent.on "crew:member:clicked crew:created", (member) ->
  //   App.navigate Routes.edit_crew_path(member.id)
  //   API.edit member.id, member

// fire this up on an global app event
}

module.exports = Header



// WEBPACK FOOTER //
// ./js/modules/header/index.js